import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

export type ConfirmNoteBarVariant = 'neutral' | 'warning';

/**
 * The inline "describe what you're about to do" bar used by both Commit and
 * Push to Production. `open` is owned by the parent; a required, non-empty
 * note is enforced here before `confirmed` fires.
 */
@Component({
    selector: 'aa-confirm-note-bar',
    templateUrl: './confirm-note-bar.component.html',
    styleUrls: ['./confirm-note-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmNoteBarComponent implements OnChanges {
  @Input() open = false;
  @Input() variant: ConfirmNoteBarVariant = 'warning';
  @Input() message: string | null = null;
  @Input() noteLabel = "Describe what you've changed or added";
  @Input() notePlaceholder = '';
  @Input() confirmLabel = 'Confirm';
  @Input() maxLength = 140;
  @Input() requiredHint = "Please describe what you're saving.";

  @Output() confirmed = new EventEmitter<string>();
  @Output() cancelled = new EventEmitter<void>();

  note = '';
  errorHint = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open'] && this.open) {
      this.note = '';
      this.errorHint = '';
    }
  }

  confirm(): void {
    if (!this.note.trim()) {
      this.errorHint = this.requiredHint;
      return;
    }
    this.confirmed.emit(this.note);
  }

  cancel(): void {
    this.cancelled.emit();
  }
}
